import { FETCH_NOTE_TYPES_SUCCEEDED } from './noteTypes.action';
import { pathOr } from 'ramda';

export const noteTypeReducer = (state = [], action) => {
	switch (action.type) {
		case FETCH_NOTE_TYPES_SUCCEEDED: {
			return pathOr([], ['payload', 'data'], action);
		}

		default: {
			return state;
		}
	}
};



// WEBPACK FOOTER //
// ./src/redux/noteTypes/noteTypes.reducer.js